import React, { FC } from "react";
import styles from "./CalenderIcon.module.scss";
import { formatCalendarDate } from "utility/date";

interface CalenderIconProps {
  date: string;
  isInPast?: boolean;
}

const CalenderIcon: FC<CalenderIconProps> = ({ date, isInPast }) => {
  const containerClassName = isInPast
    ? `${styles["calendar-icon-container"]} ${styles["calendar-icon-container-disabled"]}`
    : styles["calendar-icon-container"];

  return (
    <div className={containerClassName}>
      <div className={styles["calendar-month"]}>
        {formatCalendarDate(date).month}
      </div>
      <div className={styles["calendar-date"]}>
        {formatCalendarDate(date).day}
      </div>
    </div>
  );
};

export default CalenderIcon;
